import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import { useUpdateReferral } from '../api/apiReferral';
import { useToast } from '../../../hooks/usetoast';
import PropTypes from 'prop-types';




const schema = yup.object().shape({
    refUserCount: yup
        .number()
        .typeError("Enter a valid number")
        .required("Referral count is required")
        .integer("Only whole numbers are allowed")
        .min(0, "Count must be non-negative"),
    rewardpercent: yup
        .number()
        .typeError("Enter a valid percentage")
        .required("Reward percentage is required")
        .min(0, "Must be at least 0%")
        .max(100, "Must not exceed 100%")
});

function EditReferral({ toggle, rowData }) {
    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            refUserCount: rowData?.refUserCount || '',
            rewardpercent: rowData?.rewardpercent || '',
        }

    })
    const toast = useToast()

    const updateRef = useUpdateReferral();
    const onSubmit = async (data) => {

        let res = await updateRef.mutateAsync({
            id: rowData._id,
            refUserCount: data.refUserCount,
            rewardpercent: data.rewardpercent
        });


        if (!res?.data?.status) {
            toast.error(res?.data?.message)
            reset()
            return toggle();
        }
        toast.success(res?.data?.message)
        reset()
        toggle();
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className='mb-3'>
                <h6 className="pb-2">Level Eligible Criteria</h6>
                <Controller
                    control={control}
                    name="refUserCount"
                    render={({ field }) => (
                        <input
                            {...field}
                            type="number"
                            placeholder="Enter Referral Count"
                            className={errors.refUserCount ? 'form-control is-invalid' : 'form-control'}
                        />
                    )}
                />
                {errors.refUserCount?.message && <p className='m-0 errMsg'>{errors.refUserCount?.message}</p>}


            </div>

            <div className='mb-3'>
                <h6 className="pb-2">Reward Percentage (%)</h6>
                <Controller
                    control={control}
                    name="rewardpercent"
                    render={({ field }) => (
                        <input
                            {...field}
                            type="number"
                            step="0.01"
                            placeholder="Enter Reward Percentage"
                            className={errors.rewardpercent ? 'form-control is-invalid' : 'form-control'}
                        />
                    )}
                />
                {errors.rewardpercent?.message && <p className='m-0 errMsg'>{errors.rewardpercent?.message}</p>}
            </div>

            <div className='d-flex justify-content-center rounded-pill'>
                <button className='btn btn-primary d-flex align-items-center' disabled={updateRef.isLoading}>
                    {updateRef.isLoading ?
                        <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                        :
                        "Submit"}
                </button>
            </div>
        </form>
    )
}

EditReferral.propTypes = {
    toggle: PropTypes.any,
    rowData: PropTypes.any,
};


export default EditReferral

